// src/app/redux/sagas/modeEvaluationSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchModesEvaluationRequest,
    fetchModesEvaluationSuccess,
    fetchModesEvaluationFail,
    createModeEvaluationSuccess,
    createModeEvaluationFail,
    updateModeEvaluationSuccess,
    updateModeEvaluationFail,
    deleteModeEvaluationSuccess,
    deleteModeEvaluationFail,
    setModeEvaluationLoading,
} from "../actions/modeEvaluationActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchModesEvaluationSaga() {
    const url   = `${API_BASE_URL}/api/modes-evaluation`;
    const uid   = getUid();
    const token = getToken();

    yield put(setModeEvaluationLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchModesEvaluationSuccess(resp.data));
    } catch (e) {
        yield put(fetchModesEvaluationFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setModeEvaluationLoading(false));
    }
}

export function* createModeEvaluationSaga(action) {
    const url   = `${API_BASE_URL}/api/modes-evaluation`;
    const uid   = getUid();
    const token = getToken();

    yield put(setModeEvaluationLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createModeEvaluationSuccess(resp.data));
        yield put(fetchModesEvaluationRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Mode d'évaluation ajouté", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createModeEvaluationFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur ajout mode d'évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setModeEvaluationLoading(false));
    }
}

export function* updateModeEvaluationSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/modes-evaluation/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setModeEvaluationLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateModeEvaluationSuccess(resp.data));
        yield put(fetchModesEvaluationRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Mode d'évaluation modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateModeEvaluationFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification mode d'évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setModeEvaluationLoading(false));
    }
}

export function* deleteModeEvaluationSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/modes-evaluation/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setModeEvaluationLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteModeEvaluationSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Mode d'évaluation supprimé", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteModeEvaluationFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression mode d'évaluation", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setModeEvaluationLoading(false));
    }
}